"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDataGridDateFilterValue = exports.buildDateFilterValueFromUIDataGridFilter = exports.parseDateFilterValue = void 0;
const ui_components_1 = require("@groupby/ui-components");
const date_fns_1 = require("date-fns");
const table_config_1 = require("../../../store/shared/table-config");
const DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
const toUtcDayStartDate = (date) => (new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate())));
const toUtcDayEndDate = (date) => (new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 23, 59, 59, 999)));
const parseDateFilterValue = (value) => {
    if (value == null) {
        return undefined;
    }
    if (value instanceof Date) {
        return Number.isNaN(value.getTime()) ? undefined : value;
    }
    if (typeof value === 'number') {
        const parsedFromTimestamp = new Date(value);
        return Number.isNaN(parsedFromTimestamp.getTime()) ? undefined : parsedFromTimestamp;
    }
    if (typeof value === 'string') {
        // Filter model contract expects datetime strings; reject date-only payloads.
        if (DATE_ONLY_PATTERN.test(value)) {
            return undefined;
        }
        const parsedIsoDateTime = (0, date_fns_1.parseISO)(value);
        if ((0, date_fns_1.isValid)(parsedIsoDateTime)) {
            return parsedIsoDateTime;
        }
    }
    return undefined;
};
exports.parseDateFilterValue = parseDateFilterValue;
const parseDateTimeFilterModelValue = (value) => {
    if (typeof value !== 'string' && typeof value !== 'number' && !(value instanceof Date)) {
        return undefined;
    }
    return (0, exports.parseDateFilterValue)(value);
};
const buildDateFilterValueFromUIDataGridFilter = (operator, value) => {
    switch (operator) {
        case ui_components_1.DateFilterOperatorTypes.Range: {
            const [startRaw, endRaw] = value;
            const startAt = (0, exports.parseDateFilterValue)(startRaw);
            const endAt = (0, exports.parseDateFilterValue)(endRaw);
            if (startAt || endAt) {
                return { type: table_config_1.TableColumnFilterTypes.Date, startAt, endAt };
            }
            return null;
        }
        case ui_components_1.DateFilterOperatorTypes.After: {
            const startAt = parseDateTimeFilterModelValue(value);
            return startAt ? { type: table_config_1.TableColumnFilterTypes.Date, startAt } : null;
        }
        case ui_components_1.DateFilterOperatorTypes.Before: {
            const endAt = parseDateTimeFilterModelValue(value);
            return endAt ? { type: table_config_1.TableColumnFilterTypes.Date, endAt } : null;
        }
        case ui_components_1.DateFilterOperatorTypes.Is: {
            const dateTime = parseDateTimeFilterModelValue(value);
            return dateTime
                ? {
                    type: table_config_1.TableColumnFilterTypes.Date,
                    startAt: toUtcDayStartDate(dateTime),
                    endAt: toUtcDayEndDate(dateTime),
                }
                : null;
        }
        default:
            return null;
    }
};
exports.buildDateFilterValueFromUIDataGridFilter = buildDateFilterValueFromUIDataGridFilter;
const buildDataGridDateFilterValue = (filter) => {
    var _a, _b;
    const startAt = (_a = (0, exports.parseDateFilterValue)(filter.startAt)) === null || _a === void 0 ? void 0 : _a.getTime();
    const endAt = (_b = (0, exports.parseDateFilterValue)(filter.endAt)) === null || _b === void 0 ? void 0 : _b.getTime();
    return [startAt, endAt];
};
exports.buildDataGridDateFilterValue = buildDataGridDateFilterValue;
